import { Entity, User } from '@app/core';
import { GameStatus, GameType, IGame } from '@courses/interfaces';

export class Game extends Entity<IGame> {
  constructor(props: IGame) {
    super(props);
  }

  get id(): number {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get period(): number {
    return this.props.period;
  }

  get isAssign(): boolean {
    return this.props.isAssign;
  }

  get type() {
    return this.props.type;
  }

  get typeName(): string {
    return this.type === GameType.AUTO
      ? 'Autosim Game'
      : this.type === GameType.COMP
        ? 'Competitive Game'
        : this.type === GameType.QUIZ
          ? 'Quizz'
          : this.type === GameType.TEMP
            ? 'Template'
            : 'Unknown';
  }

  get isAutosim(): boolean {
    return this.type === GameType.AUTO;
  }

  get isCompetitive(): boolean {
    return this.type === GameType.COMP;
  }

  get isQuizz(): boolean {
    return this.type === GameType.QUIZ;
  }

  get isTemp(): boolean {
    return this.type === GameType.TEMP;
  }

  get status() {
    return this.props.status;
  }

  get isPending(): boolean {
    return this.props.status === GameStatus.PENDING;
  }

  get isPublished(): boolean {
    return this.props.status === GameStatus.PUBLISHED;
  }

  get isUnpublished(): boolean {
    return this.props.status === GameStatus.UNPUBLISHED;
  }

  get isWarmedUp(): boolean {
    return this.props.status === GameStatus.WARMEDUP;
  }

  get statusName(): string {
    return GameStatus?.[this.props.status] ?? '';
  }

  get statusClass(): string {
    return this.status === GameStatus.PUBLISHED ? 'active' : 'inactive';
  }

  get owner(): User {
    return this.props.owner && new User(this.props.owner);
  }

  get icon(): string {
    return this.props.iconfile;
  }

  get isSimulating(): boolean {
    return this.props.isSimulating;
  }

  get lastUpdatedOn(): Date | null {
    return this.props.lastUpdate && new Date(this.props.lastUpdate);
  }

  set isSimulating(value: boolean) {
    this.props.isSimulating = value;
  }
}
